import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
export default {
  props: {
    src: {
      type: String,
      default: ''
    }
  },
  components: {},
  data: function data() {
    return {};
  },
  computed: {
    styles: function styles() {
      if (!this.src) return {};
      if (/x-oss-process=/.test(this.src)) return {
        backgroundImage: "url(".concat(this.src, ")")
      };
      var src = /http/.test(this.src) ? "".concat(this.src.split('?')[0], "?x-oss-process=video/snapshot,t_1000,w_80,h_80,f_jpg,m_fast&t=").concat(new Date().getTime()) : this.src;
      var backgroundImage = "url(".concat(src, ")");
      return {
        backgroundImage: backgroundImage
      };
    }
  },
  methods: {},
  created: function created() {},
  mounted: function mounted() {},
  beforeUnmount: function beforeUnmount() {},
  watch: {}
};